import { DEFAULT_PATTERN_LAB_COLORS } from '@/shared/constants/color';

import type { Pattern } from '../model/types/pattern';

/**
 * Resolve a color for each pattern respecting project guidelines:
 * - If pattern.color is defined and non-empty, use it.
 * - Otherwise, when in multi-pattern context, use DEFAULT_PATTERN_LAB_COLORS by index (cycled).
 * - In single-pattern context with no color, return undefined to let the chart use its own default.
 */
export const getResolvedPatternColors = (
    patterns: ReadonlyArray<Partial<Pattern>>,
    isMulti: boolean,
): Array<string | undefined> => {
    const palette = DEFAULT_PATTERN_LAB_COLORS;

    return patterns.map((p, idx) => {
        const c = (p as Partial<Pattern>).color;

        if (typeof c === 'string' && c.trim().length > 0) {
            return c;
        }

        if (isMulti) {
            return palette[idx % palette.length] as string;
        }

        return undefined;
    });
};
